import BaseTable from './BaseTable'
import TableHeading from './TableHeading'
import TableCell from './TableCell'
export default {
  BaseTable,
  TableHeading,
  TableCell
}
